import { app } from "modular-openscriptjs";

const h = app("h");

export default function ExtraFeaturesModal(...args) {
    return h.$(
        h.div(
            { class: "modal-content border-0 rounded-4 shadow-lg" },
            h.div({ class: "modal-body p-4" }, ...args)
        )
    );
}
